import { useParams } from "react-router-dom";
import { UserRole } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";
import { RouteEditorCreate } from "@/pages/SV/RouteManagement/RouteEditor/RouteEditorCreate";
import { RouteEditorEdit } from "@/pages/SV/RouteManagement/RouteEditor/RouteEditorEdit";
import NotFound from "@/routes/Pages/NotFound";

import { RouteEditorMyRoute } from "./RouteEditorMyRoute";

function RouteEditor() {
    const { routeId } = useParams();
    const { role } = useAppSelector((state) => state.user);
    const { routeList } = useAppSelector((state) => state.sv);

    if (role === UserRole.Kam) {
        return <RouteEditorMyRoute />;
    }

    if (!routeId) {
        return <RouteEditorCreate />;
    }

    const currentRoute = routeList?.[routeId];

    if (!currentRoute) {
        return <NotFound />;
    }

    return <RouteEditorEdit currentRoute={currentRoute} routeId={routeId} />;
}

export default RouteEditor;
